function replaceNonAlphaNumeric(x, replaceWith = ' ') {
  // ie ?,=,&,/ etc
  const newStr = x.replace(/[\W_]+/g, replaceWith);

  return newStr;
}

export default replaceNonAlphaNumeric;
